// YERİ: src/app/domains/site/sections/ws-reveal.directive.ts
//
// Bölüm ekrana girdiğinde giriş efektini tetikler.
//
// Kullanım (section-host bölümü sarar):
//   <div [wsReveal]="'fade-up'"> … </div>
//
// ── İKİ GÜVENLİK KARARI ────────────────────────────────────────────────────
//
// 1) İÇERİK ASLA GİZLİ KALMAZ. CSS başlangıçta opaklığı 0.001 yapıyor; eğer
//    IntersectionObserver yoksa, JS bir hata verirse ya da bölüm hiç
//    gözlemlenemezse burada .ws-in ANINDA ekleniyor. "Efekt çalışmadı" kabul
//    edilebilir, "içerik görünmedi" değil.
//
// 2) EDİTÖR ÖNİZLEMESİNDE EFEKT YOK. Düzenleyen kişi bölümü sürükleyip
//    bırakırken her seferinde animasyon oynasaydı iş yavaşlar, sürükleme
//    sırasında bölüm kaybolmuş gibi görünürdü.

import {
  Directive, ElementRef, OnDestroy, OnInit, inject, input,
} from '@angular/core';

/** Editörde/kart önizlemesinde efekt çalışmasın diye kapatma bayrağı. */
export type RevealAnim = '' | 'none' | 'fade' | 'fade-up' | 'fade-down' | 'fade-left' | 'fade-right' | 'zoom-in';

@Directive({
  selector: '[wsReveal]',
  standalone: true,
})
export class WsReveal implements OnInit, OnDestroy {
  /** Efekt adı; boş/none ise hiçbir şey yapılmaz. */
  wsReveal = input<RevealAnim | string | null>('');
  /** true ise efekt tamamen atlanır (editör önizlemesi). */
  wsRevealDisabled = input<boolean>(false);

  private host = inject(ElementRef<HTMLElement>);
  private observer: IntersectionObserver | null = null;
  private safety: ReturnType<typeof setTimeout> | null = null;

  ngOnInit(): void {
    const el = this.host.nativeElement as HTMLElement;
    const anim = (this.wsReveal() ?? '').toString();

    if (!anim || anim === 'none' || this.wsRevealDisabled()) return;

    el.setAttribute('data-ws-anim', anim);

    if (typeof IntersectionObserver === 'undefined') {
      el.classList.add('ws-in');   // gözlemleyemiyorsak doğrudan göster
      return;
    }

    // GÜVENLİK AĞI: tarayıcı gözlemciyi askıya alabiliyor. Sekme ARKA PLANDA
    // açıldığında (bağlantıya orta tıklama, "yeni sekmede aç") Chrome
    // IntersectionObserver geri çağrılarını hiç çalıştırmıyor — bölümler o
    // sekmede opacity 0.001'de kalıyordu. Süre dolunca efekt atlanır ve içerik
    // olduğu gibi gösterilir; görünmeyen içerik, oynamayan animasyondan kötüdür.
    this.safety = setTimeout(() => this.reveal(el), 2500);

    this.observer = new IntersectionObserver(
      entries => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          this.reveal(el);
        }
      },
      // Bölüm biraz görününce başlasın; ekranın dibinde tetiklenirse
      // kullanıcı animasyonu hiç görmüyor.
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
    );
    this.observer.observe(el);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = null;
    if (this.safety) { clearTimeout(this.safety); this.safety = null; }
  }

  /** Bölümü görünür yap ve gözlemi bırak (tek seferlik). */
  private reveal(el: HTMLElement): void {
    el.classList.add('ws-in');
    // Geri kaydırınca tekrar oynamasın — okuma bölünmesin.
    this.observer?.disconnect();
    this.observer = null;
    if (this.safety) { clearTimeout(this.safety); this.safety = null; }
  }
}
